import { render, staticRenderFns } from "./VerdictSummaryEntity.vue?vue&type=template&id=2edad90a&scoped=true"
import script from "./VerdictSummaryEntity.vue?vue&type=script&lang=js"
export * from "./VerdictSummaryEntity.vue?vue&type=script&lang=js"
import style0 from "./VerdictSummaryEntity.vue?vue&type=style&index=0&id=2edad90a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edad90a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2edad90a')) {
      api.createRecord('2edad90a', component.options)
    } else {
      api.reload('2edad90a', component.options)
    }
    module.hot.accept("./VerdictSummaryEntity.vue?vue&type=template&id=2edad90a&scoped=true", function () {
      api.rerender('2edad90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VerdictSummaryEntity.vue"
export default component.exports